import React, { useState } from "react";
import { Link } from "react-router-dom";
import { InputWithLabelAndError } from "components/ui/InputWithLabelAndError";
import { useStateContext } from "contexts/ContextProvider";
import { requestPasswordReset } from "helpers/apiClient";

const ForgotPasswordFrame = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [errors, setErrors] = useState({});
  const { setActiveComponent } = useStateContext();

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!/\S+@\S+\.\S+/.test(email)) {
      setErrors({ email: "El email no es válido" });
      return;
    }
    try {
      await requestPasswordReset(email);
      // The Go API deliberately returns the same response for eligible and
      // ineligible accounts, preventing account enumeration.
      setMessage("Si la cuenta existe, recibirás un email para crear una nueva contraseña.");
    } catch (error) {
      setMessage(error.message || "Error conectando con el servidor");
    }
  };

  return (
    <div className="max-w-md w-full flex flex-col gap-y-4 md:gap-y-8">
      <div>
        <h2 className="font-medium leading-7 dark:text-white">Recuperar contraseña</h2>
        <span className="text-sm dark:text-gray-200">Escriba el correo y le enviaremos un enlace para restablecer la contraseña.</span>
      </div>
      <form onSubmit={handleSubmit}>
        <div className="mb-5"><InputWithLabelAndError value={email} onChange={(event) => setEmail(event.target.value)} type="email" name="email" label="Email" placeholder="johndoe@mail.com" hasFloatingLabel={false} error={errors.email} /></div>
        <button type="submit" className="mt-2 w-full bg-[#1D91E0] text-white py-2 px-4 rounded-md hover:bg-blue-600 focus:outline-none focus:bg-blue-600">Enviar correo de recuperación</button>
      </form>
      {message && <p className="text-dark-blue-950 w-fit">{message}</p>}
      <div className="flex flex-col sm:flex-row justify-between items-center gap-2">
        <p className="text-sm text-center dark:text-white">¿No te redirecciona a la pantalla de login?<Link className="inline-block text-center ml-1 text-[#1D91E0] hover:text-blue-600" onClick={() => setActiveComponent("login")}>Login</Link></p>
      </div>
    </div>
  );
};

export default ForgotPasswordFrame;
